import assign from 'lodash.assign';
export class TenderingCriterionProperty {
    constructor(init) {
        assign(this, init);
    }
    _cardinality;
    id;
    name;
    description;
    typeCode;
    valueDataTypeCode;
    valueUnitCode;
    valueCurrencyCode;
    expectedAmount;
    expectedID;
    expectedCode;
    expectedValueNumeric;
    expectedDescription;
    maximumAmount;
    minimumAmount;
    maximumValueNumeric;
    minimumValueNumeric;
    translationTypeCode;
    certificationLevelDescription;
    copyQualityTypeCode;
    applicablePeriod;
    templateEvidence;
    codeListId;
}
